import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';

@Component({
    selector: 'app-yield-by-travel-type',
    templateUrl: './yield-by-travel-type.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class YieldByTravelTypeComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Yield By Travel Type',
      chartType: FinanceDashboardChartType.Bar,
      backGroundColor:  ['#a2798f'],
      borderColor: ['#a2798f'],
      label: 'Travel Type',
      borderWith: 1
    };
  }
}
